import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { Table, Select, Input } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { getPacientesMutuas } from '../../../../state/actions/creators/pacientes.actioncreator';

const { Option } = Select;

interface MutuasSelected{
  "codigo_cliente_grupo": any,
  "beneficiario": string,
}

interface MutuasProps{
  mutuas: any,
  setMutuas: any,
  intl: any
}

interface MutuaSelectorRowProps{
  key: number,
  mutua: any,
  bNumber: any,
}

function Mutuas({ intl, mutuas, setMutuas }:MutuasProps) {
  const dispatch = useDispatch();
  const mutuasList = useSelector((state: any) => state.pacientesWorkspace.mutuas);
  const [mutuaSelector, setMutuaSelector] = useState<Array<any>>([]);

  useEffect(() => {
    dispatch(getPacientesMutuas());
  }, []);

  function changeSelect(e:any, key:number) {
    const elementsIndex = mutuas.findIndex((element:any) => element.key == key);
    const copyMutuas = [...mutuas];
    copyMutuas[elementsIndex] = { ...copyMutuas[elementsIndex], codigo_cliente_grupo: e.toString() };
    setMutuas(copyMutuas);
  }

  function changeInput(e:any, key:number) {
    const elementsIndex = mutuas.findIndex((element:any) => element.key == key);
    const copyMutuas = [...mutuas];
    copyMutuas[elementsIndex] = { ...copyMutuas[elementsIndex], beneficiario: e.target.value };
    setMutuas(copyMutuas);
  }

  const createRow = (mutua: any) => ({
    key: mutua.key,
    mutua: (
      <Input.Group>
        <Select
          getPopupContainer={(trigger:HTMLElement): any => (trigger.parentElement
            ? trigger.parentElement : null)}
          placeholder="Seleccione mutua"
          style={{ width: '100%' }}
          onChange={(e: any) => changeSelect(e, mutua.key)}
          value={mutua.codigo_cliente_grupo ? parseInt(mutua.codigo_cliente_grupo) : null}
        >
          {mutuasList.map((mutuaListElement:any) => (
            <Option
              key={mutuaListElement.codigo_grupo_cliente}
              value={mutuaListElement.codigo_grupo_cliente}
            >
              {mutuaListElement.denominacion}
            </Option>
          ))}
        </Select>
      </Input.Group>
    ),
    bNumber: <Input
      onChange={e => changeInput(e, mutua.key)}
      value={mutua.beneficiario}
    />,
  });

  useEffect(() => {
    const rows = [];
    mutuas.forEach((mutua: any) => {
      rows.push(mutua);
    });
  }, [mutuas, mutuasList]);


  const columnsInsurance = [
    {
      title: 'Mutua', dataIndex: 'mutua', key: 'mutua', width: '60%',
    },
    { title: 'Nº Beneficiario', dataIndex: 'bNumber', key: 'bNumber' },
    {
      title: 'Acciones',
      dataIndex: 'delete',

      key: 'delete',
      render: (text: any, record: any) => (mutuas.length > 0 ? (
        <p className="blueLink" onClick={() => deleteRow(record.key)}>
          Eliminar
        </p>
      ) : null),
    },
  ];

  function createDataRow() {
    setMutuas([...mutuas, { key: mutuas.length, codigo_cliente_grupo: '', beneficiario: '' }]);
  }
  function deleteRow(key: any) {
    const dataSource = [...mutuaSelector];
    setMutuaSelector(dataSource.filter(item => item.key !== key));
    setMutuas(mutuas.filter((item: { key: any; }) => item.key !== key));
  }

  return (
    <div className="bodyInfo flexCol">
      <h3>Mutuas</h3>
      <div className="table-mutuas">
        {mutuasList && (
        <Table
          columns={columnsInsurance}
          dataSource={(() => {
            const rows: Array<any> = [];
            mutuas.forEach((mutua: any) => {
              rows.push(createRow(mutua));
            });
            return rows;
          })()}
          pagination={false}
        />
        )}

      </div>
      <div className="addLine" onClick={createDataRow}>
        <div className="flexRow centerHorizontal">
          <FontAwesomeIcon className="add_line" icon={faPlus} />
          <p className="add_line" style={{ marginLeft: 8 }}>
            {intl.formatMessage({ id: 'pacientes.generic.titles.add_line' })}
          </p>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(Mutuas);
